import { render, staticRenderFns } from "./IconChibis.vue?vue&type=template&id=dd075528&"
import script from "./IconChibis.vue?vue&type=script&lang=js&"
export * from "./IconChibis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports